// extracted by mini-css-extract-plugin
module.exports = {"transcript":"Transcript_transcript__PWLZ_","transcript_over_link":"Transcript_transcript_over_link__yumpN","transcript_text":"Transcript_transcript_text__VV7li"};